import { render, staticRenderFns } from "./RequisiteSimpleDataSelect.vue?vue&type=template&id=bde38138&scoped=true"
import script from "./RequisiteSimpleDataSelect.vue?vue&type=script&lang=js"
export * from "./RequisiteSimpleDataSelect.vue?vue&type=script&lang=js"
import style0 from "./RequisiteSimpleDataSelect.vue?vue&type=style&index=0&id=bde38138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde38138",
  null
  
)

export default component.exports